import React from 'react';

export default function OwnerMessage({ content, time }) {
  return (
    <div className="flex flex-col items-end gap-1.5" data-testid="owner-message">
      <div className="max-w-[min(560px,85%)] bg-succeedo-orange/10 rounded-xl py-3 px-3.5 text-[15px] leading-[1.55] text-foreground whitespace-pre-wrap [word-break:break-word] tabular-nums">
        {content}
      </div>
      {time && <span className="font-label text-[10px] text-muted-foreground/75">You · {time}</span>}
    </div>
  );
}
